module.exports = __webpack_public_path__ + "img/logo_small.8fb33be.png";